import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=3d53fc69&scoped=true"
import script from "./MaterialDetail.vue?vue&type=script&lang=js"
export * from "./MaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialDetail.vue?vue&type=style&index=0&id=3d53fc69&prod&scoped=true&lang=css"
import style1 from "./MaterialDetail.vue?vue&type=style&index=1&id=3d53fc69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53fc69",
  null
  
)

export default component.exports